import React from "react";
import "./MainContent.scss";
export default function MainContent({ children }) {
  return (
    <section
      className={`font-[Tajawal] relative grid grid-cols-1 min-h-screen bg-gray-400/50 dark:bg-mainDark main-content gap-4_`}
    >
      {children}
    </section>
  );
}
